export default __webpack_public_path__ + "static/instagram-0d0018a6f1a3893dda95425696f884ef.png";